import { useMutation } from 'react-query';
import { getReportFutureServicesMovement } from './futureServices.services';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import arrayBufferParse from '@/utils/functions/arrayBufferParse';

interface Report {
  timestamp: string;
  status: number;
  error: string;
  path: string;
  message: string;
}

export function useFutureServicesMovementReport() {
  return useMutation(getReportFutureServicesMovement, {
    onSuccess() {
      notification.success({
        message: 'Relatório de serviços futuros gerado com sucesso!',
      });
    },

    onError(error: AxiosError<Report>) {
      const response = arrayBufferParse<Report>(error.response?.data);

      notificationError(response);
    },
  });
}
